import {IonButton, IonIcon, IonLabel} from "@ionic/react";
import {cameraOutline} from "ionicons/icons";
import type {IonButtonProps} from "app/utils/types";
import type {
  UnifiedAttachmentData,
  UseAttachmentCollectionEditorReturn
} from "app/components/hooks/useAttachmentCollectionEditor";
import {useTranslation} from "react-i18next";
import {useCallback} from "react";

type Props = Omit<IonButtonProps, "onClick"> & {
  showFileUpload: UseAttachmentCollectionEditorReturn["showFileUpload"];
  unifiedAttachments: UnifiedAttachmentData[];
};

export const UploadButton = ({showFileUpload, unifiedAttachments, ...props}: Props) => {
  const {t} = useTranslation();
  const clickHandler = useCallback(() => {
    showFileUpload();
  }, [showFileUpload]);
  return (
    <IonButton {...props} onClick={clickHandler}>
      <IonIcon icon={cameraOutline} slot="start" />
      <IonLabel>{unifiedAttachments.length > 0 ? t("g.upload-more") : t("g.upload")}</IonLabel>
    </IonButton>
  );
};
